// @ts-nocheck


import React, { useState } from 'react'
import { RightOutlined } from '@ant-design/icons'
import background from '../../../../../../public/assets/img/WomansCategory/background.png'
import e1 from '../../../../../../public/assets/img/WomansCategory/e1.png'
import e2 from '../../../../../../public/assets/img/WomansCategory/e2.png'
import e3 from '../../../../../../public/assets/img/WomansCategory/e3.png'
import e4 from '../../../../../../public/assets/img/WomansCategory/e4.png'
import e5 from '../../../../../../public/assets/img/WomansCategory/e5.png'
import e6 from '../../../../../../public/assets/img/WomansCategory/e6.png'
import e7 from '../../../../../../public/assets/img/WomansCategory/e7.png'
import e8 from '../../../../../../public/assets/img/WomansCategory/e8.png'
import e9 from '../../../../../../public/assets/img/WomansCategory/e9.png'
import e10 from '../../../../../../public/assets/img/WomansCategory/e10.png'
import Slider from 'react-slick'
import Link from 'next/link'
import { useAppDispatch } from 'src/store/store'
import { guestAccountDetailSlice } from 'src/store/slices/guestAccountDetailSlice'
import AosAnimation from 'src/utils/AosAnimation'
import { useSelector } from 'react-redux'
import { useMutation } from '@apollo/client'
import { fetchAllPeople } from 'src/store/slices/fetchAllPeopleSlice'
import { useAuth } from 'src/utils/auth'
import { useRouter } from 'next/router'
import SEND_FRIEND_REQUEST from 'src/graphql/mutations/sendFriendRequest'
import DECLINE_FRIEND_REQUEST from 'src/graphql/mutations/declineFriendRequest'
import PeopleItem from 'src/components/StoreAndProductDetailModal/PeopleModal/PeopleItem'

export default function WomanFashionEnthusiasts() {
  const Enthusiasts = [e1, e2, e3, e4, e5, e6, e7, e8, e9, e10]
  const { user } = useAuth()
  const router = useRouter()
  const dispatch = useAppDispatch()
  const peopleData = useSelector((state: any) => state?.peopleData)
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(15)

  const [sendFriendRequest] = useMutation(SEND_FRIEND_REQUEST, {
    onCompleted: () => {
      dispatch(fetchAllPeople({ limit: limit, page: page, type: 'ALL_PEOPLE', prevPost: [] }))
    },
    onError: (error) => {
      console.log(error)
    },
  })

  const [declineFriendRequest] = useMutation(DECLINE_FRIEND_REQUEST, {
    onCompleted: () => {
      dispatch(fetchAllPeople({ limit: limit, page: page, type: 'ALL_PEOPLE', prevPost: [] }))
    },
    onError: (error) => console.log(error),
  })

  const declineFriendRequestCall = (people) => {
    if (user) {
      declineFriendRequest({
        variables: { user_id: user?.id, friend_id: people?.id },
      })
    } else {
      handleRedirect()
    }
  }

  const sendFriendRequestCall = (people) => {
    if (user) {
      sendFriendRequest({
        variables: {
          friend_id: people?.id,
          user_id: user?.id,
          isActive: true,
          isFriend: true,
        },
      })
    } else {
      handleRedirect()
    }
  }

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1.5,

    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1.5,
        },
      },
    ],
  }

  const handleRedirect = () => {
    dispatch(
      guestAccountDetailSlice({
        modal: 'authModal',
        isOpen: true,
        id: {
          media: 'https://storage.googleapis.com/bluejestic-media/bluejestic-stage/loginmedia/Live-Shopping-Short.mp4',
          modalFor: 'login',
          startWith: 'loginModal',
        },
      }),
    )
  }

  return (
    <>
      <AosAnimation animationType="fade-up" duration={1000}>
        <section className="section_8">
          <div className="background">
            <img src={background.src} alt="background" />
          </div>
          <div className="container">
            <div className="subsection_1">
              <AosAnimation animationType="fade-up" duration={1000}>
                <div className="section_5_head">
                  {/* <h3>Woman Fashion Influencers</h3> */}
                  <h3>Woman Fashion Enthusiasts</h3>
                  <p>Find out women fashion inspiration from creative people around the globe</p>

                  <Link
                    href={{
                      pathname: `/fashion/women`,
                      query: { type: 'influencers' },
                    }}
                    scroll={false}
                  >
                    <a>
                      See More
                      {/* <RightOutlined /> */}
                    </a>
                  </Link>
                </div>
              </AosAnimation>
              <div className="Enthusiasts_block">
                {Enthusiasts.map((Data, i) => {
                  return (
                    <div key={i} className={`round round${i + 1}`}>
                      <div className="parent">
                        <div className="round_card">
                          <h5>Annette Black</h5>
                          <h6>Photographer</h6>
                          <p>1k Followers</p>
                          <div className="btn_block" onClick={handleRedirect}>
                            <button>Follow</button>
                          </div>
                        </div>
                      </div>
                      <img src={Data.src} alt="round1" />
                    </div>
                  )
                })}
                <div className="dots dots1"></div>
                <div className="dots dots2"></div>
                <div className="dots dots3"></div>
                <div className="dots dots4"></div>
                <div className="dots dots5"></div>
                <div className="dots dots6"></div>
              </div>
            </div>
          </div>
        </section>
        <section className="mobile-view-section-8">
          <div className="section_8_heading">
            <h4>Woman Fashion Influencers</h4>
            <Link
              href={{
                pathname: `/fashion/women`,
                query: { type: 'influencers' },
              }}
              scroll={false}
            >
              <div className="mobile_view_seeMore">
                <a>See More</a>
              </div>
            </Link>
          </div>
          <div className="section_8_details-alignment">
            <div className="section_8_details-flex-alignment">
              <Slider {...settings}>
                {peopleData?.allPeople?.map((people, i) => {
                  return (
                    <PeopleItem
                      people={people}
                      declineFriendRequestCall={declineFriendRequestCall}
                      sendFriendRequestCall={sendFriendRequestCall}
                    />
                  )
                })}
              </Slider>
            </div>
          </div>
        </section>
      </AosAnimation>
    </>
  )
}
